import React from 'react'
import classNames from 'classnames'

import { CustomNoteIcon } from '@slite/components'
import { CheckmarkIcon } from '@slite/icons'

import { Section } from '../../components/Section'

type RightItem = {
  label: string
  iconShape?: string
  iconColor?: string
}

export const SectionTwoColumns = ({
  background = 'shade-100',
  leftTitle,
  leftItems,
  rightTitle,
  rightItems,
}: {
  background?: string
  leftTitle: string
  leftItems: string[]
  rightTitle: string
  rightItems: RightItem[]
}) => {
  return (
    <Section background={background} containerTopPadding={0}>
      <div className="grid-12 grid-column-gap-24 grid-row-gap-24">
        <div
          className={classNames(
            'grid-span-6 grid-span-12-small',
            'padding-vertical-32 padding-horizontal-32 padding-horizontal-24-small'
          )}
        >
          <div className="font-family-title font-weight-medium font-size-5 margin-bottom-24">
            {leftTitle}
          </div>
          <div className="flexbox flexbox-column flexbox-gap-16">
            {leftItems.map((item) => (
              <div
                key={item}
                className="flexbox flexbox-align-center flexbox-gap-12"
              >
                <div
                  className="slite-editor-database-tag-green radius-round flexbox flexbox-centered flexbox-no-shrink"
                  style={{ width: 24, height: 24 }}
                >
                  <CheckmarkIcon size={14} />
                </div>
                <span className="font-size-5">{item}</span>
              </div>
            ))}
          </div>
        </div>
        <div
          className={classNames(
            'grid-span-6 grid-span-12-small',
            'padding-vertical-32 padding-horizontal-32 padding-horizontal-24-small',
            'background-moon-dust-lighter radius-semilarger shadow-small'
          )}
        >
          <div className="font-family-title font-weight-medium font-size-5 margin-bottom-24">
            {rightTitle}
          </div>
          <div className="flexbox flexbox-column flexbox-gap-16">
            {rightItems.map((item) => (
              <div
                key={item.label}
                className="flexbox flexbox-align-center flexbox-gap-12"
              >
                <CustomNoteIcon
                  iconShape={item.iconShape}
                  iconColor={item.iconColor}
                  size={16}
                  className="flexbox-no-shrink"
                />
                <span className="font-size-5">{item.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Section>
  )
}
